import { StatusChip } from "@platform/style";

export interface WorkItemStatusProps {
  status: string;
}

export const WorkItemStatusChip = ({ status }: WorkItemStatusProps) => {
  let icon = null;

  switch (status?.toLowerCase()) {
    case "in_progress":
      icon = <StatusChip label={"In Progress"} status={"informational"} icon={"play"}></StatusChip>;
      break;
    case "new":
      icon = <StatusChip label={"New"} status={"ice"}></StatusChip>;
      break;
    case "on_hold":
      icon = <StatusChip label={"On Hold"} status={"warning"} icon={"pause"}></StatusChip>;
      break;
    case "completed":
      icon = <StatusChip label={"Completed"} status={"success"} icon={"check"}></StatusChip>;
      break;
    case "cancelled":
      icon = <StatusChip label={"Cancelled"} status={"warning"}></StatusChip>;
      break;
  }

  return icon;
};
